<template>
    <b-container>
        <b-card>
            <b-row class="border rounded p-2 justify-content-center align-items-center mx-0">
                <b-col cols="12" lg="3" md="3" sm="12">
                    <h3 class="mb-lg-0 mb-md-0">Keyword Research</h3>
                </b-col>
                <b-col cols="12" lg="7" md="7" sm="12">
                    <b-form-group class="mb-lg-0 mb-md-0">
                        <input type="text" class="form-control" placeholder="Enter The Keyword."
                            v-model="keywordName" />
                        <small class="text-danger keyword-name-error"></small>
                    </b-form-group>
                </b-col>
                <b-col cols="6" lg="1" md="1" sm="6">
                    <b-button @click="searchKeywords" variant="outline-info" class="w-100 circle" type="submit"
                        v-b-tooltip.hover title="Search">
                        <feather-icon icon="SearchIcon" size="14" />
                    </b-button>
                </b-col>
                <b-col cols="6" lg="1" md="1" sm="6">
                    <b-button :variant="`${!checked ? 'primary' : 'outline-secondary'}`"
                        class="w-100 cursor-pointer select-none" v-b-tooltip.hover title="Filter"
                        @click="checked = !checked">
                        <feather-icon icon="FilterIcon" size="14" />
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
        <b-card v-if="!checked">
            <b-row class="border rounded mx-0 p-2">
                <b-col cols="12" lg="4" md="6" sm="12">
                    <h5 class="mb-0">Account :</h5>
                    <small class="text-muted"> Choose The Account Name. </small>
                    <v-select :clearable="false" class="mb-lg-1 mb-md-1" v-model="accountName"
                        :options="accountNames" />
                    <small class="text-danger package-name-error"></small>
                </b-col>
                <b-col lg="4" md="6" sm="12">
                    <h5 class="mb-0">Application :</h5>
                    <small class="text-muted"> Choose The Application Name. </small>
                    <v-select :clearable="false" class="mb-lg-1 mb-md-1" v-model="packageName"
                        :options="packageNames" />
                    <small class="text-danger package-name-error"></small>
                </b-col>
                <b-col lg="4" md="6" sm="12">
                    <h5 class="mb-0">Period :</h5>
                    <small class="text-muted"> Choose The Import Period. </small>
                    <v-select :clearable="false" class="mb-lg-1 mb-md-1" v-model="period" :options="periods" />
                    <small class="text-danger package-name-error"></small>
                </b-col>
                <b-col lg="4" md="6" sm="12">
                    <h5 class="mb-0">Exclude :</h5>
                    <small class="text-muted"> Exclude Ex: All, Test... </small>
                    <b-form-group>
                        <b-form-tags placeholder="Add Exclude Tags..." v-model="excludesTags"></b-form-tags>
                    </b-form-group>
                </b-col>
                <b-col lg="4" md="6" sm="12">
                    <h5 class="mb-0">Listing visitors :</h5>
                    <b-row>
                        <b-col cols="12" lg="6" md="6" sm="6">
                            <small class="text-muted">Min :</small>
                            <b-form-group>
                                <b-form-input type="number" placeholder="min..." @keypress="blockMinus" @input="fixMin"
                                    v-model="listingVisitorsMin"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6" md="6" sm="6">
                            <small class="text-muted">Max :</small>
                            <b-form-group>
                                <b-form-input type="number" placeholder="max..." @keypress="blockMinus" @input="fixMin"
                                    v-model="listingVisitorsMax"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col lg="4" md="6" sm="12">
                    <h5 class="mb-0">Acquisitions :</h5>
                    <b-row>
                        <b-col cols="12" lg="6" md="6" sm="6">
                            <small class="text-muted">Min :</small>
                            <b-form-group>
                                <b-form-input type="number" placeholder="min..." @keypress="blockMinus" @input="fixMin"
                                    v-model="acquisitionsMin"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" lg="6" md="6" sm="6">
                            <small class="text-muted">Max :</small>
                            <b-form-group>
                                <b-form-input type="number" placeholder="max..." @keypress="blockMinus" @input="fixMin"
                                    v-model="acquisitionsMax"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col lg="4" md="6" sm="12">
                    <h5 class="mb-2">Exclude All search terms & Other :</h5>
                    <input type="checkbox" style="width: 40px; height: 40px" v-model="exclude" />
                </b-col>
                <b-col lg="4" md="6" sm="12">
                    <h5 class="mb-2">Exclude (pub) :</h5>
                    <input type="checkbox" style="width: 40px; height: 40px" v-model="excludePub" />
                </b-col>
                <b-col lg="4" md="6" sm="12">
                    <h5 class="mb-2">Download Data :</h5>
                    <b-button @click="openDownloadOptionsModal"
                        :style="`cursor: ${hasData ? 'pointer' : 'not-allowed'};`"
                        :variant="`${hasData ? 'primary' : 'outline-secondary'}`" :disabled="!hasData">
                        <span class="mr-1"> Download </span>
                        <feather-icon icon="DownloadIcon" size="16" />
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
        <b-card>
            <div v-if="!isLoading && !noData">
                <b-table striped hover responsive :items="keywords" :fields="fields" :per-page="perPage"
                    :current-page="currentPage">
                    <template #cell(percentage)="data">
                        <p v-if="data.item.percentage">
                            {{ data.item.percentage.toFixed(2) }} %
                        </p>
                    </template>
                </b-table>
                <b-row>
                    <b-col cols="12" lg="6" md="6" sm="6">
                        <b-form-group class="mb-0">
                            <label class="d-inline-block text-sm-left mr-50">Per page</label>
                            <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"
                                class="w-25" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="6" md="6" sm="6">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="end"
                            size="sm" class="my-0" />
                    </b-col>
                </b-row>
            </div>
            <div style="height: 300px" v-else-if="isLoading && !noData"
                class="d-flex justify-content-center align-items-center">
                <b-spinner variant="primary" style="width: 4rem; height: 4rem" label="Large Spinner"></b-spinner>
            </div>
            <div v-else-if="!isLoading && noData" class="text-center">
                No Data Available
            </div>
        </b-card>
        <!-- Download Options Modal -->
        <b-modal id="download-options-modal" ref="downloadOptionsModalRef" title="Download Options" @ok="handleModalOk"
            @hidden="resetModal" ok-title="Download" cancel-title="Cancel" centered>
            <b-form @submit.stop.prevent="handleModalOk">
                <!-- File Type Selection -->
                <b-form-group label="Select File Type:" label-for="file-type-select">
                    <b-form-select id="file-type-select" v-model="selectedFileType" :options="fileTypeOptions"
                        required></b-form-select>
                </b-form-group>

                <!-- Filename Input -->
                <b-form-group label="Filename (without extension):" label-for="filename-input" :state="filenameState"
                    invalid-feedback="Filename cannot be empty" class="mb-2">
                    <b-form-input id="filename-input" v-model="baseFilename" required :state="filenameState"
                        placeholder="e.g., my_data" :disabled="useCurrentDateFilename"
                        @keydown.enter.prevent="triggerModalOk"></b-form-input>
                </b-form-group>

                <!-- Use Current Date Checkbox -->
                <b-form-group>
                    <b-form-checkbox id="use-date-checkbox" v-model="useCurrentDateFilename" name="use-date-checkbox"
                        @change="onCheckboxChange">
                        Use current date and time as filename
                    </b-form-checkbox>
                </b-form-group>
            </b-form>
        </b-modal>
    </b-container>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BFormTags,
    BContainer,
    BPagination,
    VBTooltip,
    BFormCheckbox,
    BTable,
    BSpinner,
    BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import axios from "@axios";
import router from "@/router";
import { removeLocalStorageItems } from "@/helper/helpers-funcs.js";

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BForm,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BButton,
        BFormTags,
        BContainer,
        BPagination,
        BFormCheckbox,
        vSelect,
        BTable,
        BSpinner,
        BModal
    },
    directives: { "b-tooltip": VBTooltip },
    data() {
        return {
            checked: false,
            keywordName: "",
            accountName: "",
            accountNames: [],
            packageName: "",
            packageNames: [],
            period: "",
            periods: [],
            exclude: false,
            excludePub: false,
            excludesTags: [],
            listingVisitorsMin: null,
            listingVisitorsMax: null,
            acquisitionsMin: null,
            acquisitionsMax: null,
            baseFilename: 'exported_data',
            filenameState: null,
            selectedFileType: 'csv',
            useCurrentDateFilename: false,
            fileTypeOptions: [
                { value: 'csv', text: 'CSV (.csv)' },
                { value: 'json', text: 'JSON (.json)' },
            ],
            isLoading: false,
            noData: false,
            keywords: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 100],
            fields: [
                {
                    key: "app",
                    label: "Application",
                },
                {
                    key: "keyword",
                    label: "Keyword",
                },
                {
                    key: "listing_visitors",
                    label: "listing visitors",
                    sortable: true,
                },
                {
                    key: "listing_acquisitions",
                    label: "Acquisitions",
                    sortable: true,
                },
                {
                    key: "percentage",
                    label: "Convertion",
                    sortable: true,
                },
                {
                    key: "account_name",
                    label: "Account",
                },
            ],
        };
    },
    computed: {
        totalRows() {
            return this.keywords.length;
        },
        hasData() {
            return this.keywords && this.keywords.length > 0;
        },
        headers() {
            if (!this.hasData || !this.keywords[0] || this.selectedFileType !== 'csv') {
                return [];
            }
            return Object.keys(this.keywords[0]);
        }
    },
    watch: {
        accountName() {
            this.getAppsByAccount();
        }
    },
    mounted() {
        this.showAllAccounts();
        this.getPeriods();
    },
    methods: {
        padZero(num) {
            return String(num).padStart(2, '0');
        },
        generateDateFilename() {
            const now = new Date();
            const year = now.getFullYear();
            const month = this.padZero(now.getMonth() + 1);
            const day = this.padZero(now.getDate());
            const hours = this.padZero(now.getHours());
            const minutes = this.padZero(now.getMinutes());
            const seconds = this.padZero(now.getSeconds());
            return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
        },
        escapeCSVValue(value) {
            if (value === null || value === undefined) return '';
            const stringValue = String(value);
            if (/[",\n\r]/.test(stringValue)) {
                return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return stringValue;
        },
        convertToCSV() {
            if (!this.hasData) return null;
            const headers = this.headers; 
            if (!headers.length) return null;

            const csvRows = [headers.map(this.escapeCSVValue).join(',')];
            this.keywords.forEach((item) => {
                const values = headers.map((header) =>
                    this.escapeCSVValue(item.hasOwnProperty(header) ? item[header] : '')
                );
                csvRows.push(values.join(','));
            });
            return csvRows.join('\n');
        },
        convertToJsonString() {
            if (!this.hasData) return null;
            try {
                return JSON.stringify(this.keywords, null, 2);
            } catch (error) {
                console.error("Error stringifying JSON data:", error);
                return null;
            }
        },
        validateBaseFilename(filename) {
            if (this.useCurrentDateFilename) return true;
            return filename?.trim().length > 0;
        },
        openDownloadOptionsModal() {
            if (!this.hasData) {
                console.warn('No data to download.');
                return;
            }
            this.resetModal();
            this.$refs.downloadOptionsModalRef.show();
        },
        onCheckboxChange(checked) {
            if (checked) {
                this.filenameState = null;
            }
        },
        handleModalOk(bvModalEvt) {
            bvModalEvt.preventDefault(); // Always prevent default close first

            let effectiveBaseFilename = '';
            let isValid = false;

            if (this.useCurrentDateFilename) {
                effectiveBaseFilename = this.generateDateFilename();
                isValid = true; // Date filename is always considered valid here
                this.filenameState = null; // Ensure no invalid state shown on disabled input
            } else {
                effectiveBaseFilename = this.baseFilename.trim();
                isValid = this.validateBaseFilename(effectiveBaseFilename);
                this.filenameState = isValid;
            }

            if (isValid && effectiveBaseFilename) {
                const finalFilename = `${effectiveBaseFilename}.${this.selectedFileType}`;
                this.performDownload(finalFilename, this.selectedFileType);
                this.$nextTick(() => {
                    this.$refs.downloadOptionsModalRef.hide();
                });
            } else if (!isValid) {
                console.log("Validation failed or filename empty.");
                // Keep modal open, invalid feedback is shown via :state
            }
        },
        triggerModalOk() {
            // Helper to trigger the modal's OK handler programmatically
            const okButton = this.$refs.downloadOptionsModalRef?.bvModal?.modal?.querySelector('.btn-primary');
            okButton?.click();
        },
        resetModal() {
            this.baseFilename = 'exported_data';
            this.selectedFileType = 'csv';
            this.useCurrentDateFilename = false;
            this.filenameState = null;
        },
        performDownload(filename, fileType) {
            let dataString = null;
            let blobType = '';

            if (fileType === 'csv') {
                dataString = this.convertToCSV();
                blobType = 'text/csv;charset=utf-8;';
            } else if (fileType === 'json') {
                dataString = this.convertToJsonString();
                blobType = 'application/json;charset=utf-8;';
            } else {
                console.error("Unsupported file type:", fileType);
                alert("Unsupported file type selected.");
                return;
            }

            if (dataString === null) { // Check specifically for null in case of conversion errors
                alert(`Could not generate ${fileType.toUpperCase()} data. Check console for errors.`);
                return;
            }

            const dataPrefix = fileType === 'csv' ? '\uFEFF' : '';
            const blob = new Blob([dataPrefix + dataString], { type: blobType });
            const link = document.createElement('a');

            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } else {
                alert(
                    "Your browser doesn't support direct downloads automatically. Please save the file manually if it opens."
                );
                if (window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                    console.warn("Fallback download method might not work well for all browsers/data types.");
                    const encodedUri = encodeURIComponent(dataPrefix + dataString);
                    window.open(`data:${blobType.split(';')[0]},` + encodedUri);
                }
            }
        },
        blockMinus(e) {
            if (e.key === '-' || e.key === 'e' || e.key === '+') {
                e.preventDefault();
            }
        },
        fixMin(e) {
            if (e.target.value < 0) {
                this.listingVisitorsMin = 0;
            }
        },
        async searchKeywords() {
            try {
                this.isLoading = true;
                this.noData = false;
                const userToken = JSON.parse(localStorage.getItem("accessToken"));

                const filterObject = {};

                if (this.keywordName) filterObject.keywordName = this.keywordName;
                if (this.accountName?.value) filterObject.accountId = this.accountName.value;
                if (this.packageName?.value) filterObject.appId = this.packageName.value;
                if (this.exclude) filterObject.exclude = this.exclude;
                if (this.excludesTags.length > 0) filterObject.excludesTags = this.excludesTags;

                if(this.excludePub) filterObject.excludePub = this.excludePub;

                if (this.listingVisitorsMin && this.listingVisitorsMin.trim() !== "") {
                    filterObject.listingVisitorsMin = parseInt(this.listingVisitorsMin);
                }

                if (this.listingVisitorsMax && this.listingVisitorsMax.trim() !== "") {
                    filterObject.listingVisitorsMax = parseInt(this.listingVisitorsMax);
                }

                if (this.acquisitionsMin && this.acquisitionsMin.trim() !== "") {
                    filterObject.acquisitionsMin = parseInt(this.acquisitionsMin);
                }

                if (this.acquisitionsMax && this.acquisitionsMax.trim() !== "") {
                    filterObject.acquisitionsMax = parseInt(this.acquisitionsMax);
                }

                let start_period, end_period;
                if (this.period?.value) {
                    [start_period, end_period] = this.period.value.split(" To ");
                    filterObject.start_period = start_period;
                    filterObject.end_period = end_period;
                }

                const response = await axios.post("/new-get-keywords", {
                    user_token: userToken,
                    ...filterObject,
                });

                if (response?.data?.status === "Unauthorized") {
                    removeLocalStorageItems();
                    router.push({ name: "auth-login" });
                    return;
                }

                if (response?.data?.keywords) {
                    if (response?.data?.keywords.length > 0) {
                        this.keywords = response.data.keywords.map((keyword) => {
                            return {
                                app: keyword.app.title,
                                keyword: keyword.name,
                                listing_visitors: keyword.listing_visitors,
                                listing_acquisitions: keyword.listing_acquisitions,
                                percentage: (keyword.listing_acquisitions * 100) / keyword.listing_visitors,
                                account_name: keyword.app.account.account_name,
                            };
                        });
                        this.isLoading = false;
                    } else {
                        this.isLoading = false;
                        this.noData = true;
                        this.keywords = [];
                    }
                    return;
                }
                this.isLoading = false;
                this.noData = true;
                this.keywords = [];
            } catch (error) {
                console.error(error);
            }
        },
        async getPeriods() {
            try {
                const userToken = JSON.parse(localStorage.getItem("accessToken"));

                const response = await axios.post("/new-get-periods", {
                    user_token: userToken,
                });

                if (response?.data?.status === "Unauthorized") {
                    removeLocalStorageItems();
                    router.push({ name: "auth-login" });
                    return;
                }

                if (response?.data?.periods) {
                    const uniquePeriods = response.data.periods
                        .reverse() // Reverse the array to start from the end
                        .filter((period, index, self) => {
                            const periodLabel = `${period.start_period} To ${period.end_period}`;
                            return (
                                self.findIndex(
                                    (p) => `${p.start_period} To ${p.end_period}` === periodLabel
                                ) === index
                            );
                        })
                        .reverse() // Reverse again to get the original order
                        .map((period) => ({
                            label: `${period.start_period} To ${period.end_period}`,
                            value: `${period.start_period} To ${period.end_period}`,
                        }));

                        this.periods = [
                            { label: 'All', value: '' },
                            ...uniquePeriods
                        ];
                    return;
                }

                removeLocalStorageItems();
                router.push({ name: "auth-login" });
            } catch (error) {
                console.error(error);
            }
        },
        async getAppsByAccount() {
            try {
                const userToken = JSON.parse(localStorage.getItem("accessToken"));
                const accountId = this.accountName.value;

                const response = await axios.post("/new-get-apps", {
                    user_token: userToken,
                    account_id: accountId,
                });

                if (response?.data?.status === "Unauthorized") {
                    removeLocalStorageItems();
                    router.push({ name: "auth-login" });
                    return;
                }

                if (response?.data?.apps) {
                    this.packageNames = [
                        { label: 'All', value: '' }, // Add "All" option first
                        ...response.data.apps.map((app) => ({
                            label: app.title,
                            value: app.id,
                        }))
                    ];
                    return;
                }


                removeLocalStorageItems();
                router.push({ name: "auth-login" });
            } catch (error) {
                console.error(error);
            }
        },
        async showAllAccounts() {
            try {
                const response = await axios.post("/get-accounts", {
                    user_token: JSON.parse(localStorage.getItem("accessToken")),
                });
                if (response?.data?.status === "Unauthorized") {
                    removeLocalStorageItems();
                    router.push({ name: "auth-login" });
                    return;
                }
                if (response?.data?.accounts) {
                    this.accountNames = [
                        { label: 'All', value: '' }, // Add "All" option first
                        ...response.data.accounts.map((account) => ({
                            label: account.account_name,
                            value: account.id,
                        }))
                    ];
                    return;
                }
                removeLocalStorageItems();
                router.push({ name: "auth-login" });
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
